import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'components/common';

export const approvalBlockers = (pr) => Array.isArray(pr?.blocked_by) ? pr.blocked_by : [];

export default function ApprovalPrerequisites({ paymentRequest: pr, onPrepareJournal }) {
  const blockers = approvalBlockers(pr);
  if (!blockers.length) return null;
  const journalRequired = blockers.some((item) => item.code === 'journal_not_created');
  return <section aria-label="Approval prerequisites" className="tw-rounded-geist-sm tw-border tw-border-solid tw-border-[#f7e2c0] tw-bg-[#fff8ee] tw-p-4 tw-text-sm tw-text-geist-fg-2">
    <p className="tw-font-semibold tw-text-geist-fg tw-m-0 tw-mb-2">Complete Accounting preparation before approving</p>
    {blockers.map((item, index) => <p key={item.code || index} className="tw-m-0 tw-mb-2">{item.message || item.code}</p>)}
    {journalRequired && <ol className="tw-m-0 tw-mb-3 tw-pl-5 tw-space-y-1">
      <li>Fill in the AX vendor code (or employee payable account) and the accounts and dimensions for each Journal line.</li>
      <li>Save the Journal details, then choose Create journal in ERP.</li>
      <li>After the Journal number appears, Sign &amp; Approve to send the request to the Chief Accountant.</li>
    </ol>}
    {onPrepareJournal && <Button size="sm" variant="primary" onClick={onPrepareJournal}>Open ERP journals</Button>}
  </section>;
}

ApprovalPrerequisites.propTypes = {
  paymentRequest: PropTypes.shape({
    blocked_by: PropTypes.arrayOf(PropTypes.shape({
      code: PropTypes.string,
      message: PropTypes.string,
    })),
  }),
  onPrepareJournal: PropTypes.func,
};
